import { createUseStyles } from 'react-jss';
import { backgrounds } from '../../utils/theme';

export default createUseStyles({
  inputGray: {
    minHeight: '40px',
    backgroundColor: backgrounds.bg3,
    borderColor: `${backgrounds.bg3} !important`,
    '& >input': {
      backgroundColor: backgrounds.bg3,
    },
  },
});
